import { Libelle } from './ui.tsx'

// Module prevu par la roadmap mais pas encore construit : l entree du menu
// existe, elle dit ou en est le module au lieu de ne rien faire.
export default function Bientot({ titre, texte, etape }: { titre: string; texte: string; etape: string }) {
  return (
    <>
      <Libelle>En conception</Libelle>
      <h1 className="ds-titre-1">{titre}</h1>
      <p className="ds-chapo">{texte}</p>
      <div className="ds-carte" style={{ marginTop: 28, maxWidth: 640 }}>
        <span className="ds-libelle">Dans la roadmap</span>
        <p style={{ margin: '14px 0 0', color: 'var(--ds-texte-2)' }}>{etape}</p>
      </div>
    </>
  )
}
